export const formatDate = (dateString, options) => {
    const date = new Date(dateString);
    return new Intl.DateTimeFormat("en-In", options).format(date);
  };

export const formatDateSlovanian = (dateString) => {
  const date = new Date(dateString);

  const formattedDate = new Intl.DateTimeFormat("sl-SI", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(date);

  const time = new Intl.DateTimeFormat("sl-SI", {
    hour: "2-digit",
    minute: "2-digit",
    hourCycle: "h23",
  }).format(date);

  const [day, month, year] = formattedDate.split(" ");

  // Map months to their genitive forms
  const monthMap = {
    januar: "januarja",
    februar: "februarja",
    marec: "marca",
    april: "aprila",
    maj: "maja",
    junij: "junija",
    julij: "julija",
    avgust: "avgusta",
    september: "septembra",
    oktober: "oktobra",
    november: "novembra",
    december: "decembra",
  };

  const correctedMonth = monthMap[month.toLowerCase()] || month;

  return `${day} ${correctedMonth} ${year}, ${time}`;
};

  